import { CreateInstance } from "./config"
const devicesUpdateAPI = CreateInstance("devices-update")
export default devicesUpdateAPI
